<div *ngIf="showMessage" class="sub-plan-exp-text mb-4" id="subscriptionValidityId">
  <span class="mt16 mb0">
    <div *ngIf="isDefaultMsg; else isVerifiedPromoTemplate" class="message-center-border">
      <p class="mb0">
      <img alt="blue info icon"
        aria-hidden="true"
        class="pb10 mr10 float-left blue-info-icon"
        src="ocsp-web-ui/dist/assets/images/default_msg_info_icon.svg">
        <span [innerHTML]="message" class="message-center" id="statusMessage"></span>
      </p>
    </div>
    <ng-template #isVerifiedPromoTemplate>
      <div *ngIf="isVerifiedPromoMsg; else displayErrorMsg" class="promo-verified-border">
        <p class="mb0">
          <img alt="green check icon"
               aria-hidden="true"
               class="pb10 mr10 float-left"
               src="ocsp-web-ui/dist/assets/images/green-checkmark.svg">
          <span [innerHTML]="message" class="message-center" id="statusMessage"></span>
        </p>
      </div>
    </ng-template>
    <ng-template #displayErrorMsg>
      <div class="mb16 error-border">
        <img alt="red cross error image"
             aria-hidden="true"
             class="pb10 mr10 float-left red-cross-error-icon"
             src="ocsp-web-ui/dist/assets/images/error-close-icon.svg">
        <span [innerHTML]="message" class="error-message-center" id="statusMessage"></span>
      </div>
    </ng-template>
  </span>
</div>
